module.exports = __webpack_public_path__ + "static/CV-c85224bc72eb023e1878ece9ce1c73cb.pdf";